import { getAllPostsLabelTranslation } from '@wix/communities-blog-client-common';
import { getQueryLocale } from './locale-selectors';

export const getViewerAllPostsLabelTranslation = (state, language) =>
  getQueryLocale(state) ? getAllPostsLabelTranslation(state, language) : '';
